import { useEffect, useState } from 'react';
import { EVENTO_VETO } from '../../utils/demo';

/**
 * Aviso cuando el backend rechaza una escritura por ser la demostración.
 *
 * Escucha el evento que emite el envoltorio de fetch, así que cubre cualquier
 * botón de la aplicación sin tocarlos uno a uno. Fuera de la demo el evento no
 * se emite nunca y esto no pinta nada.
 */
export default function DemoVetoToast() {
  const [mensaje, setMensaje] = useState<string | null>(null);

  useEffect(() => {
    let temporizador: ReturnType<typeof setTimeout>;

    const alVetar = (e: Event) => {
      setMensaje((e as CustomEvent<string>).detail ||
        'Esto no se puede hacer en la demostración.');
      clearTimeout(temporizador);
      temporizador = setTimeout(() => setMensaje(null), 6000);
    };

    window.addEventListener(EVENTO_VETO, alVetar);
    return () => {
      window.removeEventListener(EVENTO_VETO, alVetar);
      clearTimeout(temporizador);
    };
  }, []);

  if (!mensaje) return null;

  return (
    <div
      role="status"
      className="fixed left-1/2 top-20 z-[200] w-[min(28rem,calc(100vw-2rem))] -translate-x-1/2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 shadow-lg dark:border-amber-800 dark:bg-amber-950"
    >
      <p className="text-sm text-amber-900 dark:text-amber-200">{mensaje}</p>
    </div>
  );
}
